export function isValidRG(rg) {
   // Remove pontos, hífens e espaços
   rg = rg.replace(/[^\dXx]/g, "").toUpperCase();

   // RG geralmente possui de 7 a 9 caracteres (último pode ser X)
   if (!/^\d{7,8}[\dX]$/.test(rg)) {
      return false;
   }

   // Rejeita todos os dígitos iguais
   const digits = rg.replace("X", "");
   if (/^(\d)\1+$/.test(digits)) {
      return false;
   }

   return true;
}